import { getGroupBusinessInvites } from '@disco/state-management/selectors/groups'
import { useCallback, useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'hooks/use-redux'
import type { BusinessShare } from 'types/group'
import { loadGroupBusinessInvites } from '@disco/state-management/actions/GroupActions'
type LoadBusiness = {
  businessInvites: BusinessShare[]
  isLoading: boolean
}
export const useLoadBusinesses = (channelId: number): LoadBusiness => {
  const dispatch = useDispatch()
  const [isLoading, setIsLoading] = useState(true)
  const businessInvites = useSelector(state =>
    getGroupBusinessInvites(state, {
      groupId: channelId,
    }),
  )
  const loadBusinesses = useCallback(async () => {
    await dispatch(loadGroupBusinessInvites(channelId))
    setIsLoading(false)
  }, [channelId])
  useEffect(() => {
    loadBusinesses()
  }, [loadBusinesses])
  return {
    businessInvites,
    isLoading,
  }
}
export const extractSubdomain = (domain: string): string => {
  const parts = domain.split('.')

  if (parts.length > 2) {
    return parts.slice(0, parts.length - 2).join('.')
  }

  return parts[0]
}
